/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "NavMenu" }]*/

'use strict';

function NavMenu(args) {
    let defargs = {
        activemenu_class: '',
        elementid: null,
        menuid: '',
        menuitems_class: '',
        scroll_into_view: false,
    };

    let $rootMenu = null;

    $.extend(defargs, args);

    if (defargs.elementid === null) {
        throw new Error('Invalid arguments passed to NavMenu constructor.');
    }

    if (defargs.menuid.length === 0) {
        defargs.menuid = 'Navmenu-' + Math.round(1000 * Math.random());
    }

    initialize();

    function initialize() {
        $rootMenu = $('#' + defargs.elementid).children('ul');

        // Wrap menu items in 2 containers
        $rootMenu.wrap("<div class='navmenu-container'><div class='navmenu-items " + defargs.menuitems_class + "'></div></div>");

        // Set menu ID
        $rootMenu.attr('id', defargs.menuid);

        // Setup navigation
        setupMenu();

        // Ensure active menu item is visible
        expandToActive();

        return true;
    }

    function wrapMenuItem($lis) {
        $lis.each(function () {
            let $li = $(this);

            // Wrap menu item text and submenu (if present) in <div>
            let $ul = $li.children('ul');
            if ($ul.length !== 0) {
                wrapMenuItem($ul.children('li'));

                $ul.detach();

                let menutext = $("<div class='menu-item-txt'>" + $li.html() + '</div>');

                $li.empty();

                let submenu = $("<div class='submenu'></div>");
                submenu.append($ul);

                $li.append(menutext);
                $li.append(submenu);
            } else {
                let menutext = $("<div class='menu-item-txt'>" + $li.html() + '</div>');

                $li.empty();
                $li.append(menutext);
            }
        });
    }

    function setupMenu() {
        wrapMenuItem($rootMenu.children());

        $('li', $rootMenu).each(function () {
            let $li = $(this);

            $(this).addClass('menu-item');

            if ($(this).children('.submenu').length > 0) {
                // Expand or collapse submenu when clicked
                $('>div.menu-item-txt', this).on('click', function (event) {
                    if (event.target === this) {
                        event.preventDefault();

                        toggleSubmenu($li);
                    }
                });

                $(this).addClass('has-submenu');
            } else {
                // Navigate to destination when clicked
                $('>div.menu-item-txt', this).on('click', function (event) {
                    if (event.target === this) {
                        event.preventDefault();

                        if (!$li.is('.' + defargs.activemenu_class)) {
                            let $link = $li.find('>div >a');

                            if ($link.length !== 0) {
                                window.location.href = $link.attr('href');
                            }
                        }
                    }
                });
            }

            // Fade in and out when cursor enters
            {
                $('>div.menu-item-txt', this).on('mouseenter', function () {
                    $('.menu-item-hover').not($li).removeClass('menu-item-hover');
                    $li.addClass('menu-item-hover');
                });

                $('>div.menu-item-txt', this).on('mouseleave', function () {
                    $li.removeClass('menu-item-hover');
                });
            }

            // Keyboard navigation support
            {
                let $link = $('>div >a', this);
                if ($link.length !== 0) {
                    $link.on('keyup', function (event) {
                        if (event.key === 'Tab') {
                            let $menitm = $(this).parent().closest('li');

                            expandToElement($menitm);
                        }
                    });

                    $link.on('focusin', function () {
                        let $menitm = $(this).parent().closest('li');

                        $menitm.addClass('menu-item-focus');
                    });

                    $link.on('focusout', function () {
                        let $menitm = $(this).parent().closest('li');

                        $menitm.removeClass('menu-item-focus');
                    });
                }
            }
        });
    }

    function toggleSubmenu(menitm) {
        let $menitm = $(menitm);

        if (!$menitm.hasClass('submenu-open')) {
            $menitm.addClass('submenu-open');
        } else {
            $menitm.removeClass('submenu-open');
        }
    }

    function expandToActive() {
        const $activeElement = $('.' + defargs.activemenu_class, $rootMenu);
        if ($activeElement.length === 0) {
            return;
        }

        expandToElement($activeElement);

        if (defargs.scroll_into_view) {
            setTimeout(() => $activeElement.get(0).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }), 0);
        }
    }

    function expandToElement(element) {
        let $e = $(element);
        if ($e.length === 0) {
            return;
        }

        if ($e.hasClass('has-submenu')) {
            $e.addClass('submenu-open');
        }

        $e.parents('li.menu-item.has-submenu').addClass('submenu-open');
    }
}
